import React, { useState, useEffect } from "react";
import Button from "../../Button";
import apiInstance from "../../apiInstance";

const EditPaymentPopup = ({
    data,
    type = "add",
    updatePayment,
    addPayment,
    updateError,
    closePopup,
}) => {
    const [payment, setPayment] = useState({
        id: data?.payment?._id || "",
        subscriptionId: data?.payment?.subscriptionId || '',
        status: data?.payment?.status || '',
        amount: data?.payment?.amount || process.env.REACT_APP_STRIPE_MONTHLY_PRICING,
        methodDetail: data?.payment?.methodDetail || '',
    });

    const [subscriptions, setSubscriptions] = useState([]); 
    const [fieldErrors, setFieldErrors] = useState({}); 

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPayment((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = () => {
        const apiCall =
            type === "update"
                ? apiInstance.put(`/devadmin/payment/${payment.id}`, payment)
                : apiInstance.post(`/devadmin/payment`, payment);

        apiCall
            .then((response) => {
                const returnedPayment = response.data.payment;
                if (type === "update") {
                    updatePayment(returnedPayment);
                } else {
                    addPayment(returnedPayment);
                }
                closePopup();
            })
            .catch((error) => {
                console.log(error);
                if (error.response) {
                    if (
                        error.response.status === 400 &&
                        error.response.data.fieldErrors
                    ) {
                        setFieldErrors(error.response.data.fieldErrors);
                    } else {
                        updateError(error.response.data.message || 'Something went wrong, please try again later.');
                    }
                }
            });
    };

    useEffect(() => {
        apiInstance
            .get("/devadmin/subscription")
            .then((res) => {
                setSubscriptions(res.data.subscriptions || []);
            })
            .catch((err) => {
                console.error("Error fetching subscriptions:", err);
                updateError("Failed to load subscriptions.");
            });
    }, []);

    return (
        <div className="mjsdev-pp">
            <h2>{type === "add" ? "ADD PAYMENT" : "EDIT PAYMENT"}</h2>

            <form>

                <div className="mjsdev-input-field">
                    <label htmlFor="subscriptionId">Subscription</label>
                    <select
                        name="subscriptionId"
                        value={payment.subscriptionId}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Subscription</option>
                        {subscriptions.map((sub) => (
                            <option key={sub._id} value={sub._id}>
                                {sub.siteName}
                            </option>
                        ))}
                        
                    </select>
                    {fieldErrors.subscriptionId && (
                        <span className="mjsdev-error">
                            {fieldErrors.subscriptionId}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="status">Status</label>
                    <select
                        name="status"
                        value={payment.status}
                        onChange={handleInputChange}
                    >
                        <option value="">Select Status</option>
                        <option value="paid">Paid</option>
                        <option value="unpaid">Unpaid</option>
                        <option value="failed">Failed</option>
                        <option value="pending">Pending</option>
                        <option value="open">Open</option>
                        
                    </select>
                    {fieldErrors.status && (
                        <span className="mjsdev-error">
                            {fieldErrors.status}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="amount">Amount($)</label>
                    <input
                        type="number"
                        placeholder="Amount($)"
                        name="amount"
                        value={payment.amount}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.amount && (
                        <span className="mjsdev-error">
                            {fieldErrors.amount}
                        </span>
                    )}
                </div>

                <div className="mjsdev-input-field">
                    <label htmlFor="methodDetail">Method</label>
                    <input
                        type="text"
                        placeholder="methodDetail Eg visa, ****1234"
                        name="methodDetail"
                        value={payment.methodDetail}
                        onChange={handleInputChange}
                    />
                    {fieldErrors.methodDetail && (
                        <span className="mjsdev-error">
                            {fieldErrors.methodDetail}
                        </span>
                    )}
                </div>

            </form>

            <div className="mjsdev-pp-actions">
                <Button
                    name={type === "add" ? "Add" : "Update"}
                    eventHandler={handleSubmit}
                />
                <Button name="Cancel" eventHandler={closePopup} />
            </div>
        </div>
    );
};

export default EditPaymentPopup;
